export default __webpack_public_path__ + "static/paypal_logo-00a8a0bbbcd4813b87bbf0f6ed6e8634.png";